import { ClaimsSection } from "@/features/patient/insurance/components/ClaimsView";

// No claims API yet, so the page shows its empty state until one exists.
export function ClaimsPage() {
  return <ClaimsSection claims={[]} />;
}
